import { IMAGES } from "./images";

export const TEAM_MEMBERS = [
  {
    name: "N. Singh Rajput",
    role: "Founder & CEO",
    image: IMAGES.founderPortrait,
  },
  {
    name: "Dr. Meera Desai",
    role: "Head of Admissions",
    image: IMAGES.testimonials[0],
  },
  {
    name: "Arjun Kapoor",
    role: "Visa Specialist",
    image: IMAGES.testimonials[1],
  },
  {
    name: "Sneha Reddy",
    role: "Scholarship Coordinator",
    image: IMAGES.testimonials[2],
  },
  {
    name: "David Chen",
    role: "SOP Writing Lead",
    image: IMAGES.testimonials[3],
  },
  {
    name: "Kavita Nair",
    role: "Student Relations Manager",
    image: IMAGES.testimonials[0],
  },
];
